import { useObserver } from "mobx-react-lite";
import { useAddLabelStore, usePipedriveStore } from "../..";
import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer from "./InputContainer";

export const addLabelOptionValue = "AddLabel";

export default <T,>({ name, label, formik }: IInputProps<T, number>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <PipedriveLabelInputSlim name={name} formik={formik} />
        </InputContainer>
    );
}

export const PipedriveLabelInputSlim = <T,>({ name, formik }: ISlimInputProps<T, number>) => {
    const pipedriveStore = usePipedriveStore();
    const addLabelStore = useAddLabelStore();
    const labelOptions = useObserver(() => pipedriveStore.labelOptions);

    return (
        <select
            name={name as string}
            value={formik.values[name] ? String(formik.values[name]) : ""}
            onChange={e => e.target.value === addLabelOptionValue
                ? addLabelStore.open(labelId => formik.setFieldValue(name as string, labelId))
                : formik.setFieldValue(name as string, e.target.value === "" ? null : Number(e.target.value))}
            onBlur={formik.handleBlur}
        >
            <option value="">----</option>
            {labelOptions.map(o => (
                <option key={o.id} value={o.id}>{o.label}</option>
            ))}
            <option value={addLabelOptionValue}>+ Add Label</option>
        </select>
    );
}
